import React from "react"
import styled from "styled-components"
import { rem } from "polished"

import { media } from "@sr/common"
import { Caption } from "../Typography"

export interface MediaBlockImgProps {
  alt?: string
  className?: string
  height?: number
  float?: "left" | "right" | "none" | "center"
  src: string
  width?: number
  caption?: string
}

const MediaBlockImg = ({
  alt,
  className,
  height,
  float = "none",
  src,
  width,
  caption,
}: MediaBlockImgProps) => {
  const styleWidth = width ? { width: `${width}px` } : undefined;

  return (
    <MediaBlockImgStyle
      className={`block-img ${className || ""}`}
      float={float}
    >
      {caption ? (
        <figure className="block-img__figure" style={{ margin: 0, ...styleWidth }}>
          <img
            alt={alt}
            className="block-img__img"
            height={height}
            src={src}
            width={width}
            style={styleWidth}
          />
          <figcaption className="block-img__caption"><Caption>{caption}</Caption></figcaption>
        </figure>
      ) : (
        <img
          alt={alt}
          className="block-img__img"
          height={height}
          src={src}
          width={width}
          style={styleWidth}
        />
      )}
    </MediaBlockImgStyle>
  );
};

export default MediaBlockImg

interface ImgSC {
  float: "left" | "right" | "center" | "none";
}

const MediaBlockImgStyle = styled.div<ImgSC & { float?: string }>`
  @media ${media.stMidUp} {
    ${({ float }) => {
      if (float === "left" || float === "right") {
        return `
          float: ${float};
          width: 50% !important;
          padding-top: ${rem(16)};
          padding-right: ${float === "left" ? rem(24) : "0"};
          padding-bottom: ${rem(16)};
          padding-left: ${float === "right" ? rem(24) : "0"};
        `;
      }
      if (float === "center") {
        return `
          display: flex !important;
          justify-content: center;
          width: 100%;
          padding-top: ${rem(16)};
          padding-bottom: ${rem(16)};
        `;
      }
      return "";
    }}
  }

  .block-img__figure {
    margin: 0;
    ${({ float }) =>
      float === "center"
        ? "text-align: center; width: auto;"
        : ""}
  }

  .block-img__img {
    height: auto;
    ${({ float }) =>
      float === "center"
        ? ""
        : "display: block;"}
    ${({ float }) =>
      float === "center"
        ? "display: inline-block;"
        : float === "none" || !float
        ? "width: 100%;"
        : ""}
  }

  .block-img__caption {
    text-align: center;
    margin-top: ${rem(8)};
    
    strong {
      font-weight: 400;
    }
  }
`